import { UPDATE_DATE } from "./types";

const updateDate = (date) => ({
  type: UPDATE_DATE,
  date,
});

export default updateDate;
